/*!
 *
 *	input-instagram.js
 *
 */


module.exports = function(){
	var token = '6418034212.eb38719.fbd2304931444b59b5ac7287506b4608';
	var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + token;
	var limit = 5;

	var buildData = function(data){
		var $elem = '';
		var _limit = limit;
		if( _limit > data.length ){
			_limit = data.length;
		};
		for( var i=0; i<_limit; i++){
			$elem += '<div class="top-Instagram_Item"><a href="'+ data[i].link +'" target="_blank"><img src="'+ data[i].images.standard_resolution.url +'" alt=""></a></div>'
		};
		$('#InstagramInput').append($elem);
	};

	$.ajax({
		url: url,
		dataType: 'json'
	}).done(function(data){
		//console.log( data.data );
		buildData(data.data);
	}).fail(function(a){
		console.log(a)
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/input-instagram.js
// module id = 16
// module chunks = 0